import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentUpload } from '@client/components/tools/document-analyzer/DocumentUpload';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer/upload')({
    staticData: {
        breadcrumb: {
            title: 'Upload document',
        },
        // The page heading is the route's, as on the sibling History tab: a heading drawn in the tab
        // content sat under the "Document analyser" H1 at a larger size than the H1 itself.
        ui: {
            title: 'Upload document for analysis',
            subtitle:
                'Upload a document to automatically detect potential regulatory breaches. Currently supported documents: FSG (Financial Services Guide), complaints policy, and conflict of interest policy.',
        },
    },
    component: UploadPage,
});

function UploadPage() {
    return (
        <PageController route={Route}>
            <div className="p-6">
                <div className="mx-auto max-w-4xl">
                    <DocumentUpload />
                </div>
            </div>
        </PageController>
    );
}
